import type { ElementType, ReactNode } from 'react'

import './system.css'

export type StackGap = 'xs' | 'sm' | 'md' | 'lg' | 'section'

export function Stack({
  as: As = 'div',
  gap = 'md',
  direction = 'column',
  justify,
  align,
  wrap = false,
  className,
  children,
}: {
  as?: ElementType
  gap?: StackGap
  direction?: 'column' | 'row'
  justify?: 'between'
  align?: 'start'
  wrap?: boolean
  className?: string
  children: ReactNode
}) {
  const classes = ['stack', `stack--gap-${gap}`]

  if (direction === 'row') {
    classes.push('stack--row')
  }

  if (justify) {
    classes.push(`stack--${justify}`)
  }

  if (align) {
    classes.push(`stack--align-${align}`)
  }

  if (wrap) {
    classes.push('stack--wrap')
  }

  if (className) {
    classes.push(className)
  }

  return <As className={classes.join(' ')}>{children}</As>
}
